<template>
    <div class="context-left-side">
        <GoogleMapLoader>
        </GoogleMapLoader>
    </div>
</template>
<script>
    import GoogleMapLoader from "./GoogleMapLoader";

    export default {
        name: "ContentLeftSide",
        components: {GoogleMapLoader},
        computed: {
        },
        methods: {
        }
    }
</script>

<style scoped>
    .context-left-side {
        padding: 0;
        margin: 0;
        max-height: 100%;
        max-width: 100%;
    }


</style>